import { Component, OnInit } from '@angular/core';

import { DemoPassportService } from '../../../../../providers/demo-passport-service/demo-passport-service';
import { EventLoggerService } from '../../../../../providers/event-logger/event-logger-service';
import { FeatureFlipService } from '../../../../../providers/feature-flip-service/feature-flip.service';
import { NavigationService } from '../../../../../providers/navigation-service/navigation-service';
import { ScanService } from '../../../../../providers/scan-service/scan-service';
import { TabsService } from '../../../../../providers/tabs/tabs.service';
import { WalletConnectService } from '../../../../../providers/wallet-connect-service/wallet-connect.service';

@Component({
	selector: 'app-scanner',
	templateUrl: './scanner.component.html',
	styleUrls: ['./scanner.component.scss'],
})
export class ScannerComponent implements OnInit {
	isLightOn = false;

	constructor(
		private navigationService: NavigationService,
		public featureFlipService: FeatureFlipService,
		private demoPassportService: DemoPassportService,
		private eventLogger: EventLoggerService,
		private scanService: ScanService,
		private walletConnectService: WalletConnectService,
		private tabsService: TabsService,
	) {}

	async ngOnInit() {}

	requestDemoPassport() {
		this.eventLogger.logEvent('getDemoPassport', {});
		this.demoPassportService.getDemoPassport();
	}

	toogleLight() {
		if (!this.isLightOn) {
			this.scanService.enableLight();
			this.isLightOn = true;
		} else {
			this.scanService.disableLight();
			this.isLightOn = false;
		}
	}

	navigationBack() {
		this.tabsService.hideTabsMenu.next(false);
		this.navigationService.back();
	}

	walletConnectCompatible() {
		this.walletConnectService.displayCompatibleModal().then();
	}
}
